import { isFileVideo } from '../../media/video';
import { UploadingMethods } from '../../../components/forms/file-upload';

const uploadMethodSpecifier = file => UploadingMethods.File + UploadingMethods.Cloud
  + (isFileVideo(file) ? UploadingMethods.Ftp : UploadingMethods.None);

export default uploadMethodSpecifier;
